export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const ROUTER_BASENAME = (() => {
  if (!PUBLIC_URL) {
    return '';
  } else if (/^(\/|https?:\/\/)/.test(PUBLIC_URL)) {
    const link = document.createElement('a') as HTMLAnchorElement;
    link.href = PUBLIC_URL;
    const path = link.pathname;
    return path.endsWith('/') ? path.substr(0, path.length - 1) : path;
  } else {
    // tslint:disable-next-line
    console.warn(new Error(`Invalidated PUBLIC_URL ${JSON.stringify(PUBLIC_URL)}`));
    return '';
  }
})();

// 自动跳到相应的子路径
if (typeof location === 'object' && !location.pathname.startsWith(ROUTER_BASENAME)) {
  location.assign(ROUTER_BASENAME);
}

export function pathTo(path: string): string {
  return ROUTER_BASENAME + '/' + path;
}

export function staticPathTo(path: string): string {
  if (/\/$/.test(PUBLIC_URL)) {
    return `${PUBLIC_URL}${path}`;
  } else {
    return `${PUBLIC_URL}/${path}`;
  }
}

export function imgPathTo(name: string): string {
  return staticPathTo('static/img/' + name);
}



// WEBPACK FOOTER //
// ./src/services/lib/path.ts